var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookpost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2143",
    "data-name": "\\uC0AC\\uAC01\\uD615 2143",
    width: 12.854,
    height: 24,
    fill: "#a2a2a2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_5102",
    "data-name": "\\uADF8\\uB8F9 5102",
    transform: "translate(8377 16532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_5099",
    "data-name": "\\uADF8\\uB8F9 5099",
    transform: "translate(-8363.428 -16524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_5098",
    "data-name": "\\uADF8\\uB8F9 5098",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_285",
    "data-name": "\\uD328\\uC2A4 285",
    d: "M12.012,13.5l.667-4.343H8.511V6.338A2.172,2.172,0,0,1,10.96,3.991h1.895V.293A23.129,23.129,0,0,0,9.491,0C6.059,0,3.815,2.08,3.815,5.846V9.156H0V13.5H3.815V24h4.7V13.5Z",
    fill: "#a2a2a2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_287",
    "data-name": "\\uD0C0\\uC6D0 287",
    transform: "translate(-8377 -16532)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.75,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookpost);
export default __webpack_public_path__ + "static/media/facebookpost.9bc4e6932865e93c08c6eb374ff62be0.svg";
export { ForwardRef as ReactComponent };